import UserAsset from "./UserAsset";
import { resourcesBaseUrl } from "../../editor/core/EditorConstants";
import { ACLResourceType } from "./ACLResourceType";

export default class UserAssetAudio extends UserAsset {
  wideoId?: string;

  constructor(
    id: string,
    name: string,
    url: string,
    userId: string,
    preview: string,
    duration: number,
    wideoId?: string) {
    super(
      id, 
      name, 
      url, 
      userId, 
      resourcesBaseUrl + "/img/editor/icons/default-audio.png", 
      duration, 
      false, 
      wideoId || null, 
      null,
    );
    this.wideoId = wideoId || null;
  }

  public getAssetType = () => {
    return "userAudios";
  }

  public getACLResourceType = () => {
    return ACLResourceType.ASSET_AUDIO;
  }

}
